import { supabase } from '../supabaseClient';

/**
 * Most recently opened workspace for a user.
 * Order: last_opened_at DESC NULLS LAST, then created_at DESC.
 */
export const resolveMostRecentWorkspace = async (userId) => {
  if (!userId) return null;

  const { data, error } = await supabase
    .from('workspaces')
    .select('id, name')
    .eq('user_id', userId)
    .order('last_opened_at', { ascending: false, nullsFirst: false })
    .order('created_at', { ascending: false })
    .limit(1)
    .maybeSingle();

  if (error) throw error;
  return data;
};

export const getWorkspaceDetailPath = (workspace) => {
  if (!workspace?.id) return '/workspace';
  return `/workspace/${workspace.id}`;
};

/** Path for post-auth home: most recent workspace, or /workspace gate if none. */
export const resolveWorkspaceHomePath = async (userId) => {
  const workspace = await resolveMostRecentWorkspace(userId);
  return getWorkspaceDetailPath(workspace);
};

/**
 * Navigate to resumed workspace home (or /workspace gate when the user has none).
 * @returns {Promise<{ path: string, workspace: { id: string, name: string } | null }>}
 */
export const navigateToResumedWorkspace = async (navigate, userId, options = {}) => {
  const { replace = false } = options;
  const workspace = await resolveMostRecentWorkspace(userId);
  const path = getWorkspaceDetailPath(workspace);

  navigate(path, {
    replace,
    state: {
      ...(workspace?.name ? { workspaceName: workspace.name } : {}),
      workspaceOpenSource: 'default_resume',
    },
  });

  return { path, workspace };
};
